<template>
  <div class="dialog__container" ref="messages" @scroll="handleScroll">
    <div class="container__empty" v-if="chatMessages.length === 0">
      <div class="empty__text">
        <div class="heading__wrapper">
          <p class="heading heading_size_h1">Привет!</p>
          <img src="@/assets/KazIllustrations/emoji/hello.png" class="heading__image" />
        </div>
        <p class="body body_size_M">Я — Казатель GPT, твой помощник по учёбе. Задавай свой вопрос — ответ найдётся.</p>
      </div>
    </div>

    <Message v-for="(message, index) in chatMessages" :key="index" :message="message"/>
    <div class="loading-message" v-if="loading">
      <div class="loading-spinner"></div>
      <kaz-loader/>
      <p class="label label_size_M" v-if="showTypingText">{{ typingText }}</p>
    </div>
    <kaz-button
      v-if="showScrollButton"
      :label="''"
      :size="'M'"
      :leftIcon="true"
      :leftIconName="'kuiIconChevronDownLarge'"
      :appearance="'primary'"
      class="button_type_scroll"
      @click="scrollToBottomSmooth"
    />
  </div>
</template>

<script>
import Message from './Message.vue';
import KazLoader from '@/components/KazUI/atoms/loader';
import KazButton from '@/components/KazUI/atoms/button';

const LOAD_REMINDER_INTERVAL = 20000;
const REMINDER_VARIANTS = [
  'Подожди ещё немного...',
  'Осталось пара мгновений!',
  'Ещё пару штрихов!',
  'Терпения, друг! Терпения!',
  'Ответ уже близко. Спасибо за ожидание.',
  'Бот ещё думает!',
  'Светлая мысль вот-вот озарит бота!',
  'Мы ценим ваше терпение. Ответ скоро будет готов.'
];

export default {
  name: 'message-container',

  components: {
    Message,
    KazLoader,
    KazButton
  },

  props: {
    chatMessages: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    limitExceeded:{
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showTypingText: true,
      typingText: 'Уже пишу тебе ответ...',
      loadingReminder: null,
      showScrollButton: false,
      userScrolledUp: false
    };
  },

  watch: {
    loading: {
      handler(newValue) {
        if (newValue) {
          this.loadingReminder = setInterval(
            this.handleLoadReminder(),
            LOAD_REMINDER_INTERVAL
          );
        } else {
          clearInterval(this.loadingReminder);
          this.loadingReminder = null;
        }
      },
      immediate: true
    },
    chatMessages: {
      handler() {
        if (!this.userScrolledUp) {
          this.scrollToBottomSmooth();
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    handleLoadReminder(initialInd = 0) {
      const totalVariants = REMINDER_VARIANTS.length;
      return () => {
        this.typingText = REMINDER_VARIANTS[initialInd];
        initialInd = ++initialInd % totalVariants;
      };
    },
    scrollToBottomSmooth() {
      const messages = this.$refs.messages;
      if (messages) {
        messages.scrollTo({
          top: messages.scrollHeight,
          behavior: 'smooth'
        });
      }
    },
    handleScroll() {
      const messages = this.$refs.messages;
      const isBottom = messages.scrollHeight - messages.scrollTop === messages.clientHeight;
      this.showScrollButton = !isBottom;
      this.userScrolledUp = !isBottom;
    },
  },

  // updated() {
  //   this.$nextTick(() => {
  //     this.scrollToBottomSmooth();
  //   });
  // },

};
</script>

<style scoped>
button {
  display: none;
  position: fixed;
  bottom: 164px;
  right: 16px;
  z-index: 1000;
}

.dialog__container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  scrollbar-width: none;
  height: 100%;
  overflow-y: auto;
}

.dialog__container::-webkit-scrollbar {
  display: none;
}

.loading-message {
  width: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
}

.container__empty {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  padding: 32px;
  background-color: var(--kaz-base-base-01);
  background-image: url('@/assets/KazIllustrations/brand/persona.png');
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
  border-radius: 16px;
  gap: 32px;
  margin: auto;
}
.empty__text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.empty__text p {
  color: var(--kaz-textIcons-text-02);
  max-width: 330px;
}
.heading__wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.heading__image {
  width: 36px;
  height: 36px;
}
.empty__info {
  --kaz-base-base-09: var(--kaz-textIcons-text-03);
}

@media screen and (max-width: 992px) {
  .container__empty {
    height: fit-content;
    padding: 16px;
    gap: 16px;
    margin: auto;
  }
  button {
    display: block;
  }
}

@media screen and (max-width: 568px) {
  .container__empty {
    background-image: none;
  }
}
</style>
